import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import { DataGrid, GridRow, Spacer, Tooltip, Typography, Select, MenuItem, SearchField, CurrencyFormattedDisplay } from '@emburse/embark-core';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { isWordInEntry } from './utils';
const StatusMapping = {
    Ready: 'CPS5',
    Settling: 'CPS3',
    Processing: 'CPS3',
    Funded: 'CPS8',
    Declined: 'CPS4',
    Failed: 'CPS4',
    Rejected: 'CPS4',
    Review: 'CPS4',
    Voided: 'CPS4'
};
function HistoryTable({ loading, data }) {
    useTranslation();
    const [filterLoading, setFilterLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [isFilteringData, setIsFilteringData] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [searchFilter, setSearchFilter] = useState('');
    useEffect(() => {
        if (searchFilter.length === 0 && (!statusFilter || statusFilter.length === 0)) {
            setFilteredData([]);
            setIsFilteringData(false);
        }
        else {
            setFilteredData(data.filter((value) => (searchFilter.length ? isWordInEntry(value, searchFilter) : true) &&
                (statusFilter.length ? value.PaymentStatus === statusFilter : true)));
            setIsFilteringData(true);
        }
        setFilterLoading(false);
    }, [statusFilter, searchFilter, data]);
    const searchChangeHandler = useCallback((value) => {
        if (!filterLoading) {
            setFilterLoading(true);
        }
        setSearchFilter(value);
    }, [filterLoading]);
    const updateStatusFilter = (newFilter) => {
        if (!filterLoading) {
            setFilterLoading(true);
        }
        setStatusFilter(newFilter === 'All' ? '' : newFilter);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Spacer, { size: 30 }), _jsxs(GridRow, { style: { columnGap: 8 }, children: [_jsx(SearchField, { sx: { mt: { xs: 4 } }, label: $t('Search'), id: "history-search-input", disabled: loading, doSearchOnChange: true, onChangeTimeout: 250, searchAction: searchChangeHandler }), _jsxs(Select, { sx: { mt: { xs: 4 } }, id: "status-flter-select", value: statusFilter && statusFilter.length ? statusFilter : 'All', label: $t('Status'), onChange: (e) => updateStatusFilter(e.target.value), children: [_jsx(MenuItem, { value: "All", children: $t('All') }, "All"), Object.keys(StatusMapping).map((status) => (_jsx(MenuItem, { value: status, children: status }, status)))] })] }), _jsx(Spacer, { size: 30 }), _jsx(DataGrid, { loading: loading || filterLoading, autoHeight: true, pageSizeOptions: [5, 10, 20], columns: [
                    {
                        field: 'ReimbursedDate',
                        headerName: $t('Reimbursed Date'),
                        width: 120,
                        renderCell: (cell) => (_jsx(Tooltip, { title: cell.value, children: _jsx(Typography, { noWrap: true, children: cell.value }) }))
                    },
                    {
                        field: 'EmployeeName',
                        headerName: $t('Employee Name'),
                        width: 160,
                        renderCell: (cell) => _jsx(Typography, { noWrap: true, children: cell.value })
                    },
                    {
                        field: 'ReportName',
                        headerName: $t('Report Name'),
                        width: 270,
                        renderCell: (cell) => _jsx(Typography, { children: cell.value })
                    },
                    {
                        field: 'ApprovalCode',
                        headerName: $t('Approval Code'),
                        width: 120,
                        renderCell: (cell) => _jsx(Typography, { noWrap: true, children: cell.value })
                    },
                    {
                        field: 'Amount',
                        headerName: $t('Amount'),
                        width: 120,
                        renderCell: (cell) => {
                            return (_jsx(CurrencyFormattedDisplay, { amount: cell.row.Amount, code: cell.row.Currency }));
                        }
                    },
                    {
                        field: 'PaymentStatusText',
                        headerName: $t('Payment Status'),
                        width: 400,
                        renderCell: (cell) => (_jsx("div", { style: {
                                whiteSpace: 'normal' // show all the text while being wrapped
                            }, children: _jsx(Typography, { children: cell.value || '-' }) }))
                    }
                ], rows: isFilteringData ? filteredData : data, initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 20
                        }
                    }
                } })] }));
}
export default HistoryTable;
